import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function Shell() {
  return (
    <div className="min-h-screen bg-slate-200/60 p-6">
      <div className="mx-auto max-w-[1400px] rounded-2xl bg-white/70 shadow-sm ring-1 ring-black/5 backdrop-blur">
        <div className="flex">
          <Sidebar />
          <div className="flex-1">
            <Topbar />
            <main className="p-6">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
